import React from 'react'

const AdobeCheatsheet = () => {
    return (
        <div style={{ height: 'calc(100vh - 95px)' }}>
            <iframe title='adobecheatsheet' src="https://docs.google.com/spreadsheets/d/1-P7q8GM_jPWlwBNdLQpU6vad7FAtJy9qziWMPMoTLks/edit?usp=sharing" width="100%" height="100%"></iframe>
        </div>
    )
}

export default AdobeCheatsheet;